import { apiOrgLive, apiWithEntityId, apiWithOrg } from 'services/api';
import { APPLICATION_CENTER } from '../type';
import {
  action,
  actionFailure,
  actionSuccess,
  FETCH_APPLICATION_CENTER_DOCUMENTS,
  SUBMIT_APPLICATION_CENTER_DOCUMENTS,
} from '../actions';
import { useStateValue } from '../..';
import axios, { AxiosError } from 'axios';

const useApplicationCenter = () => {
  const { state, dispatch } = useStateValue();
  const { applicationCenter } = state;

  const toFetchDocuments = async () => {
    dispatch(action(FETCH_APPLICATION_CENTER_DOCUMENTS));
    try {
      const response = await apiWithOrg.get('/app_center');
      dispatch(actionSuccess(FETCH_APPLICATION_CENTER_DOCUMENTS, response?.data));
    } catch (e) {
      const error: any = axios.isAxiosError(e) ? e?.response : e;
      if (error?.response?.status >= 400 ) {
        dispatch(actionFailure(FETCH_APPLICATION_CENTER_DOCUMENTS, error?.data));
      }
      dispatch(actionFailure(FETCH_APPLICATION_CENTER_DOCUMENTS, e));
    }
  };

  const toUploadDocuments = async (
    values: APPLICATION_CENTER.IDocumentManagement
  ) => {
    dispatch(action(SUBMIT_APPLICATION_CENTER_DOCUMENTS));
    try {
      const response = await apiWithOrg.put(
        '/app_center/documents',
        values
      );
      dispatch(actionSuccess(SUBMIT_APPLICATION_CENTER_DOCUMENTS, response));
    } catch (e) {
      dispatch(actionFailure(SUBMIT_APPLICATION_CENTER_DOCUMENTS, e));
    }
  };
  const deleteDocument = async (upload_id: string | undefined) => {
    try {
      if (upload_id) await apiOrgLive.remove(`/uploads/${upload_id}`);
    } catch (e) {
      console.log(e);
    }
  };

  return {
    applicationCenter,
    toFetchDocuments,
    toUploadDocuments,
    deleteDocument
  };
};

export default useApplicationCenter;
